import { Box } from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';
import DropDownSuggestions from 'component/drop-down-suggestions';
import React, { useEffect, useState } from 'react';
import themes from 'styles/themes';
import { useStyles } from './style';
import { ReactComponent as FilterIcon } from '../../assets/svg/filterIcon.svg';

export default function AutoCompleteSearch({
    setInputSearch,
    value,
    handler,
    suggestions,
    hasFilter = false,
    handleFilterOpen,
}: any) {
    const [displaySuggestion, setDisplaySuggestion] = useState(false);
    const [inputValue, setInputValue] = useState(value);
    const classes = useStyles();

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleOptionClick = async (suggestion) => {
        setInputValue(suggestion);
        await setInputSearch(suggestion);
        handler({ key: 'Enter', suggestion: suggestion });
    };

    const handleOnChangeSearch = async (event) => {
        setInputValue(event.target.value);
        await setInputSearch(event.target.value);
        if (value || event.target.value) {
            setDisplaySuggestion(true);
        }
    };

    const handleOnFocusSearch = (event) => {
        if (event) {
            setDisplaySuggestion(true);
        }
    };

    const onCloseOption = (e) => {
        setTimeout(() => {
            handler({ key: 'Enter', suggestion: e.target.value });
            setDisplaySuggestion(false);
        }, 500);
    };

    const handleOnKeyDown = (e) => {
        handler(e);
        if (e.key === 'Enter') {
            setDisplaySuggestion(false);
        }
    };

    return (
        <>
            <div className={classes.searchWrap}>
                <input
                    className={classes.input}
                    type="text"
                    value={inputValue}
                    onChange={(event) => handleOnChangeSearch(event)}
                    onFocus={(event) => handleOnFocusSearch(event)}
                    onKeyDown={handleOnKeyDown}
                    onBlur={onCloseOption}
                    placeholder="Search"
                    style={{
                        caretColor: themes.palette.primary.main,
                    }}
                />
                <span style={{ position: 'absolute', left: 20, top: 0 }}>
                    <SearchOutlined className={classes.searchIcon} />
                </span>
                {hasFilter && (
                    <span
                        style={{ position: 'absolute', right: 20, top: 0, cursor: 'pointer' }}
                        onClick={handleFilterOpen}
                    >
                        <FilterIcon />
                    </span>
                )}
            </div>
            <Box px={'24px'}>
                <DropDownSuggestions
                    displaySuggestion={displaySuggestion}
                    suggestions={suggestions}
                    handleOptionClick={handleOptionClick}
                />
            </Box>
        </>
    );
}
